const lang = {
    en: {
        cart_title: "Tickets",
        cart_steps: ['Tickets', 'Review', 'Payment'],
        // cart_step_1: "Tickets",
        // cart_step_2: "Review",
        // cart_step_3: "Payment",
        // payment_title: "Payment Options",
        // menu_tickets: "TICKETS",
        // menu_tickets_caption: "Admission to the park",
        // menu_excursion: "EXCURSION",
        // menu_excursion_caption: "Admission and Transfer Service to the park",
        // select: "SELECT",
        choose_your_tickets: 'Choose Your Tickets',

        payment_options: "Payment options",
        method_credit_card: "Pay with credit card",
        method_paypal: "Pay with PayPal",
        method_xpay: "Pay with XPay",

        btnNext: "NEXT",
        btnBack: "BACK",
        btnPayment: "GO TO PAYMENT",

        full_name: "Full name",
        phone: 'Phone (with your country code)',
        email: "Email",
        confirm_email: "Confirm Email",
        hotel: "Hotel",

        billing_message: "Please provide your billing information in order to proceed to payment",
        country: "Country",
        country_select: "choose bill country",
        state: "State",
        city: "City",
        zip: "Zip",
        address: "Address",

        free: "FREE",
        total: "Total",

        terms_checkbox: "I have read and agree with the",
        terms_and_conditions: "Terms and Conditions",
        privacy_policy: "Privacy Policy",
        terms_link: 'https://watercity.gr/terms-of-use/',
        privacy_policy_link: 'https://watercity.gr/privacy-policy/',

        marketing: {
            permissions_label: "Newsletter Marketing Permission",
            what_to_expect: "What to expect",
            consent_title: "I give my consent to Watercity to contact me for information, offers or news of the park.",
            consent_text: "<strong>What to expect:</strong> If you wish to withdraw your consent and stop receiving newsletters, you can do so from the link at the bottom of each newsletter or contact us at info@watercity.gr. We respect your privacy and your personal data. By submitting this form you give permission to process your data in accordance with our Privacy Policy.",
        },

        alerts: {
            no_full_name: "Please type your full name.",
            no_hotel: "Please type the name of your hotel.",
            no_phone: "Please type your phone number so we can contact with you.",
            read_terms: "Please confirm that you have read and agree with the Terms and Conditions.",
            invalid_email: "Please type a valid email address.",
            confirm_email: "Email confirmation does not match.",
            no_bill_info: "Please fill in all the fields in billing information."
        },

        // ADULT: {
        //     title: "ADULTS",
        //     admissionTitle: "General Admission",
        //     discountedOptions: [
        //         'NON REFUNDABLE',
        //         'VALID FROM [VALID-FROM]',
        //         'All games (Kids - Advanced - Xtreme)',
        //     ],
        //     flexyTitle: "Flexy",
        //     flexyOptions: [
        //         'REFUNDABLE & TRANSFERABLE',
        //         'VALID FROM [VALID-FROM]',
        //         'All games (Kids - Advanced - Xtreme)',
        //     ],
        //     ticketsLabel: "No. of adults",
        // },
        // CHILD: {
        //     title: "KIDS",
        //     admissionTitle: "Kids Admission",
        //     discountedOptions: [
        //         'NON REFUNDABLE',
        //         'VALID FROM [VALID-FROM]',
        //         'Only Kids & Advanced games',
        //     ],
        //     flexyOptions: [
        //         'REFUNDABLE & TRANSFERABLE',
        //         'VALID FROM [VALID-FROM]',
        //         'Only Kids & Advanced games',
        //     ],
        //     ticketsLabel: "No. of kids",
        // },
        // SMALL: {
        //     title: "TODDLER",
        //     admissionTitle: "Toddler",
        //     ticketsLabel: "No. of toddler",
        // },


        // kids: "Kids",
        // valid_from: "VALID FROM",
        // today: "TODAY",
        //
        // hot_to_pay: "How to pay",
        //

        //
        // alert_fullname: "Please type your fullname.",
        // alert_email: "Please type your email.",
        // alert_country: "Please choose your country.",
        // alert_state: "Please type your state.",
        // alert_city: "Please type your city.",
        // alert_zip: "Please type your zip code.",
        // alert_address: "Please type your address.",
    },

    el: {
        cart_title: "Προσφορά Watercity!",
        cart_steps: ['Εισιτήρια', 'Ανασκόπηση', 'Πληρωμή'],
        choose_your_tickets: 'Εισιτήρια',

        payment_options: "Τρόπος πληρωμής",
        method_credit_card: "Πληρωμή με Πιστωτική - Χρεωστική Κάρτα",
        method_paypal: "Πληρωμή με Paypal",
        method_xpay: "Πληρωμή με XPay",

        btnNext: "ΕΠΟΜΕΝΟ",
        btnBack: "ΠΙΣΩ",
        btnPayment: "ΠΛΗΡΩΜΗ",

        full_name: "Όνομα",
        phone: 'Τηλέφωνο',
        email: "Email",
        confirm_email: "Επιβεβαίωση Email",
        hotel: "Ξενοδοχείο",

        billing_message: "Καταχωρίστε τα στοιχεία χρέωσής σας για να προχωρήσετε στην πληρωμή",
        country: "Χώρα",
        country_select: "επιλογή χώρας",
        state: "Νομός",
        city: "Πόλη",
        zip: "Τ.Κ.",
        address: "Διεύθυνση",

        free: "ΔΩΡΕΑΝ",
        total: "Σύνολο",

        terms_checkbox: "Έχω διαβάσει και συμφωνώ με τους",
        terms_and_conditions: "Όρους και Προϋποθέσεις",
        privacy_policy: "Πολιτική Απορρήτου",
        terms_link: 'https://watercity.gr/terms-of-use/',
        privacy_policy_link: 'https://watercity.gr/privacy-policy/',

        marketing: {
            permissions_label: "Επιθυμώ να λαμβάνω Newsletter",
            what_to_expect: "Τι να περιμένω",
            consent_title: "Δίνω τη συγκατάθεσή μου στο Watercity να επικοινωνήσει μαζί μου για πληροφορίες, προσφορές ή νέα για το πάρκο.",
            consent_text: "<strong>Τι να περιμένετε:</strong> Εάν θέλετε να αποσύρετε τη συγκατάθεσή σας και να σταματήσετε να λαμβάνετε ενημερωτικά δελτία, μπορείτε να το κάνετε από τον σύνδεσμο στο κάτω μέρος κάθε ενημερωτικού δελτίου ή να επικοινωνήσετε μαζί μας στο info@watercity.gr. Σεβόμαστε το απόρρητο και τα προσωπικά σας δεδομένα. Υποβάλλοντας αυτή τη φόρμα, δίνετε άδεια για την επεξεργασία των δεδομένων σας σύμφωνα με την Πολιτική απορρήτου μας.",
        },

        alerts: {
            no_full_name: "Πληκτρολογήστε το όνομά σας",
            read_terms: "Επιβεβαιώστε ότι έχετε διαβάσει και συμφωνείτε με τους Όρους και Προϋποθέσεις.",
            invalid_email: "Πληκτρολογήστε μια έγκυρη διεύθυνση email.",
            confirm_email: "Η επιβεβαίωση email δεν ταιριάζει.",
            no_bill_info: "Συμπληρώστε όλα τα πεδία στα στοιχεία χρέωσης."
        },
    },
}

export {
    lang
}